import { DateService } from './date-service'

export const dateService = new DateService()
export { type IDateService } from './date-service'
